import * as types from '../actionTypes';

const initialState = {
    stepData: {
      0: {},
      1: {},
      2: {},
      3: {},
      4: {},
      5: {}
    },
    servicesList: [],
    discountsList: [],
    specialitiesList: [],    
  };
  
  export const partnerReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_SERVICES_LIST':
        return { ...state, servicesList: action.payload };
      case 'SET_DISCOUNTS_LIST':
        return { ...state, discountsList: action.payload };        
      case 'SET_SPECIALITIES_LIST':
        return { ...state, specialitiesList: action.payload };      
      case 'RESET_PARTNER_STEP_DATA':
        return {
          ...state,
          stepData: {
            0: {},
            1: {},
            2: {},
            3: {},
            4: {},
            5: {}
          }
        };
      case 'UPDATE_STEP_DATA':
        return {
          ...state,
          stepData: {
            ...state.stepData,
            [action.payload.stepIndex]: {
              ...state.stepData[action.payload.stepIndex],
              ...action.payload.data
            }
          }
        };
      default:
        return state;
    }
  };
  
  
  